<script setup lang="ts">
import MedicationCheckupPosologyLine from "@/medication-checkup/components/MedicationCheckupPosologyLine.vue";
import {useTreatmentSelectionsStore} from "@/medication-checkup/stores/treatment-selections-store";

/**
 * The treatments retained so far, under their task in the checklist of the
 * step, while the review is live: the selection followed at a glance, each
 * posology one pencil away.
 */

const selection = useTreatmentSelectionsStore();
</script>

<template>
  <div v-if="selection.blockId !== null" class="ml-2 mt-1.5 border-l-2 border-solid border-gray-light pl-[15px]">
    <span v-if="selection.retained.length === 0" class="block text-[11px] leading-snug text-muted-foreground">
      Cochez les traitements dans le fil : ils s'ajoutent ici.
    </span>

    <ul v-else class="m-0 flex list-none flex-col gap-1.5 rounded-md bg-gray-light !px-2.5 !py-2">
      <li
        v-for="line in selection.retained"
        :key="line.id"
        class="flex min-w-0 flex-col"
      >
        <span class="truncate text-[10.5px] text-gray-dark/80" :title="line.label">
          {{ line.label }}
        </span>
        <MedicationCheckupPosologyLine
          :posology="selection.posology(line)"
          editable
          asked
          dense
          @edit="selection.edit(line)"
        />
      </li>
    </ul>
  </div>
</template>
